<script>
import { defineComponent } from "vue";
const name = 'PdfCartaPropostaQuantidadePreco'

export default defineComponent({
  name,

  components: { }, 

  props: {
    orcamentoDatas: {
      type: Array,
      default: () => []
    },

   },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

});
</script>

<template>
    <ol>
      <li>
          <p>Quantidade</p>
          <p>Preço Unitário</p>  
      </li>
        <li v-for="data,index in orcamentoDatas" 
        :key="index" 
        :class="{diferent:index % 2 === 0}"
        >
            <p>{{data.quantidadeFormatada}}</p>
            <p>R$ {{data.valorPrecoIdealFormatado}}</p>
        </li>
    </ol>
</template>


<style scoped>
p{
  margin: 8px;
  font-size: 14px;
}
ol {
  padding: 0;
  list-style: none;
  width: 45%;
  background-color: #f9f9f9;
  display:  flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 8px;
}

li {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(1fr,auto-fill);
  align-items: center;
  justify-items: center;
  width: 95%;
}

.diferent{
  background-color: #e3e3e3 !important;
}
</style>
